import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, mergeMap, Observable } from 'rxjs';
import { FileLayerResponse } from '../models/file-layer.model';
import { UploadService } from './upload.service';

@Injectable()
export class ReadLayersService {
  constructor(private http: HttpClient, private uploadService: UploadService) {}

  generateLayerUrlFromFile(file: File): Observable<string> {
    return this.uploadService.uploadFile(file);
  }

  readKmlFile(
    file: File,
    outSR?: Partial<__esri.SpatialReference>
  ): Observable<FileLayerResponse> {
    return this.generateLayerUrlFromFile(file).pipe(
      mergeMap((url) => {
        const params = new HttpParams({
          fromObject: {
            url,
            model: 'simple',
            outSR: JSON.stringify(outSR ?? { wkid: 4326 }),
          },
        });

        return this.http.get<any>(`~kmlUtility`, { params });
      }),
      map<any, FileLayerResponse>((res) => {
        return {
          layers: res?.featureCollection?.layers ?? [],
          folders: res?.folders ?? [],
        };
      })
    );
  }

  readShapefile(file: File): Observable<FileLayerResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const publishParameters = {
      name: file.name,
      maxRecordCount: 1000,
      enforceInputFileSizeLimit: true,
      enforceOutputJsonSizeLimit: true,
      generalize: true,
      maxAllowableOffset: 10,
      reducePrecision: false,
    };

    const params = new HttpParams({
      fromObject: {
        filetype: 'shapefile',
        publishParameters: JSON.stringify(publishParameters),
        f: 'json',
      },
    });

    return this.http.post<any>(`~uploadShapeFile`, formData, { params }).pipe(
      map<any, FileLayerResponse>((res) => {
        return {
          layers: res?.featureCollection?.layers ?? [],
          folders: res?.folders ?? [],
        };
      })
    );
  }
}
